import React from 'react';
import './Question.css';

function capitalize(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

const QuestionStep = ({ question, options, onSelect, onBack, stepNumber, totalSteps }) => {
  return (
    <div className="question-container">
      <div className="navigation-header">
        <h2>{question.text}</h2>
      </div>

      <div className="keywords-grid">
        {options.map((option) => (
          <button
            key={option.value}
            className={option.className ? option.className : "keyword-button"}
            onClick={() => onSelect(option.value)}
          >
            {capitalize(option.label)}
          </button>
        ))}
      </div>

      <div className="progress-indicator">
        {stepNumber >= 1 ? (
          <button className="back-button" onClick={onBack}>
            ← Undo
          </button>
        ) : (
            <></>
        )}
        Step {stepNumber+1} of {totalSteps+1}
      </div>
    </div>
  );
};

export default QuestionStep;
